import { REALTIME_HEADER } from "./model"
import { invariant } from "@/utils"

export default (response: Response) => {
  const header = response.headers.get(REALTIME_HEADER)
  invariant(header, "Missing Realtime header")

  const [channel, event] = header.split(":")
  invariant(channel, "Unable to parse channel from Realtime header")
  invariant(event, "Unable to parse event from Realtime header")

  return [channel, event] as const
}
